module.exports = __webpack_public_path__ + "img/icon-coins.32d6f595.svg";